import { createFileRoute } from "@tanstack/react-router";
import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";

import taskarooLogo from "@/assets/taskaroo2.png";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_landing/")({
  component: Home,
});

function Home() {
  const { theme, setTheme } = useTheme();
  return (
    <div>
      {/* Light/dark mode toggle */}

      <button
        className="absolute top-0 right-0 m-4"
        onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      >
        {theme === "light" ? (
          <MoonIcon className="size-6" />
        ) : (
          <SunIcon className="size-6" />
        )}
      </button>

      {/* Hero Section */}
      <section className="min-h-[90vh] flex lg:flex-row flex-col items-center justify-center lg:gap-20">
        <div className="flex gap-2 lg:gap-6 min-h-[80vh] items-center">
          <img
            src={taskarooLogo}
            alt="Taskaroo Logo"
            className="size-[120px] lg:size-[180px]"
          />
          <div className="flex flex-col items-start justify-left gap-4 max-w-md">
            <h1 className="text-5xl font-semibold -ml-1">Taskaroo</h1>
            <h2 className="text-2xl font-medium">
              Task management, right in Telegram
            </h2>
            <p className="text font-medium text-muted-foreground">
              Organize projects, assign tasks, and collaborate seamlessly
              without leaving your team chat
            </p>
            <Button
              asChild
              className="h-11 text-lg bg-[#AE7050] text-gray-50 hover:bg-[#AE7050]/80 mt-2"
            >
              <a
                href={`https://t.me/${import.meta.env.VITE_BOT_USERNAME}`}
                target="_blank"
              >
                Get Started
              </a>
            </Button>
          </div>
        </div>
        <PhoneMockup />
      </section>
    </div>
  );
}

function PhoneMockup() {
  return (
    <div className="relative border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[600px] w-[300px]">
      <div className="h-[32px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[72px] rounded-s-lg"></div>
      <div className="h-[46px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[124px] rounded-s-lg"></div>
      <div className="h-[46px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -start-[17px] top-[178px] rounded-s-lg"></div>
      <div className="h-[64px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -end-[17px] top-[142px] rounded-e-lg"></div>
      <div className="rounded-[2rem] overflow-hidden w-[272px] h-[572px] bg-white dark:bg-gray-800">
        <img
          src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/hero/mockup-1-light.png"
          className="dark:hidden w-[272px] h-[572px]"
          alt="Light mockup"
        />
        <img
          src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/hero/mockup-1-dark.png"
          className="hidden dark:block w-[272px] h-[572px]"
          alt="Dark mockup"
        />
      </div>
    </div>
  );
}
